import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { BreadcrumbItem, BreadcrumbMergeStrategy } from './breadcrumb.models';

@Injectable({ providedIn: 'root' })
export class BreadcrumbService {
  private readonly manualItems$ = new BehaviorSubject<BreadcrumbItem[]>([]);
  private readonly strategy$ = new BehaviorSubject<BreadcrumbMergeStrategy>('auto');

  // Observables para o componente
  getManualItems$(): Observable<BreadcrumbItem[]> { return this.manualItems$.asObservable(); }
  getStrategy$(): Observable<BreadcrumbMergeStrategy> { return this.strategy$.asObservable(); }

  // Métodos para o dev configurar via TS
  setManualItems(items: BreadcrumbItem[]): void {
    this.manualItems$.next(items ?? []);
  }

  addManualItem(item: BreadcrumbItem): void {
    const next = [...this.manualItems$.value, item];
    this.manualItems$.next(next);
  }

  clearManualItems(): void {
    this.manualItems$.next([]);
  }

  setMergeStrategy(strategy: BreadcrumbMergeStrategy): void {
    this.strategy$.next(strategy);
  }
}


